import {Nullable, OffersManagementListing, OffersManagementListingItem} from 'common/types';
import {
  FETCH_OFFERS_MANAGEMENT_LISTING_FAILURE,
  FETCH_OFFERS_MANAGEMENT_LISTING_REQUEST,
  FETCH_OFFERS_MANAGEMENT_LISTING_SUCCESS,
  OFFER_SELECT,
  OffersAction,
} from '../types';

interface State {
  offerSelected: null|OffersManagementListingItem;
  data: Nullable<OffersManagementListing>;
  isFetching: boolean;
  error: Nullable<Error>;
}

const initialState: State = {
  offerSelected: null,
  data: null,
  isFetching: false,
  error: null,
};

export const managementReducer = (
  state: State = initialState,
  action: OffersAction
) => {
  switch (action.type) {
    case OFFER_SELECT:
      return {
        ...state,
        offerSelected: action.payload.offer,
      };

    case FETCH_OFFERS_MANAGEMENT_LISTING_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };

    case FETCH_OFFERS_MANAGEMENT_LISTING_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
      };
    case FETCH_OFFERS_MANAGEMENT_LISTING_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };

    default:
      return state;
  }
};
